import React from "react"
import { StyleSheet } from "react-native"
import { useStyle } from "react-native-style-utilities"

import { useIsDarkMode } from "./AppThemeContextProvider"
import { Box } from "./Box"
import { COLORS } from "./theme/colors"

import type { BoxProps } from "./Box"

const styles = StyleSheet.create({
  dark: {
    backgroundColor: COLORS.$background.dark,
  },
  light: {
    backgroundColor: COLORS.$background.light,
  },
})

export function Background({ style, ...rest }: BoxProps) {
  const isDark = useIsDarkMode()
  return (
    <Box
      style={useStyle(() => {
        return [isDark ? styles.dark : styles.light, style]
      }, [isDark, style])}
      {...rest}
    />
  )
}
